module.exports = __webpack_public_path__ + "img/semi_stopped.c201b986.svg";